import {ModalityEnum} from 'domain/usecases/private/refund/request-preview';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';

const {therapies, hospitalizations} =
	translations['pt-br'].privateFlow.refund.previewServiceType.refundForm;

export const radioOpts = [
	{
		label: therapies,
		value: ModalityEnum.THERAPIES,
		dataTagId: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_TERAPIAS,
	},
	{
		label: hospitalizations,
		value: ModalityEnum.HOSPITALIZATIONS,
		dataTagId: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_INTERNACAO,
	},
];

export const MODALITY_LABEL = {
	[ModalityEnum.THERAPIES]: therapies,
	[ModalityEnum.HOSPITALIZATIONS]: hospitalizations,
};

export const DESCRIPTION_MAX_LENGTH = 1000;
